import styled from 'styled-components';

interface TextOverFlowProps {
  width: number;
  title?: string;
  children: JSX.Element | string;
}

const TextOverFlowWrapper = styled.span<{ width: number }>`
  max-width: ${({ width }) => `${width}px`};
  display: inline-block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

function TextOverFlow({ width, title, children }: TextOverFlowProps) {
  return (
    <TextOverFlowWrapper title={title} width={width}>
      {children}
    </TextOverFlowWrapper>
  );
}

export default TextOverFlow;
